import { ShopId } from 'constants/shop';

/** Base path config for magazine  */
export const pathConfig: {
  [key in ShopId]?: string;
} & {
  'no-config': 'no-config';
} = {
  [ShopId.DE]: 'magazin',
  [ShopId.CH]: 'magazin',
  'no-config': 'no-config',
};

/** Base path for magazine  */
export const magazineBathPath = pathConfig[process.env.SHOP_ID];
